import React from 'react';
import { Redirect } from 'react-router-dom';

import useUser from 'hooks/useUser';
import Loading from 'components/Loading';
import RoutedLayout from 'components/Layout/RoutedLayout';
import routes from './routes';

const Administration = () => {
  const { isSuperUser, loading } = useUser();

  if (loading) {
    return <Loading />;
  }

  if (!isSuperUser) {
    return <Redirect to="/" />;
  }

  return (
    <RoutedLayout routes={routes} sidebar />
  );
};

export default Administration;
